import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptors
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ======================== Wheel/Minigame Functions ========================

/**
 * Lấy tất cả Minigame/Wheel
 */
export const fetchLoadingWheel = async () => {
  try {
    const response = await apiClient.get('/api/minigame/all');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching wheel:', error);
    throw error.response?.data || { message: 'Failed to fetch wheel' };
  }
};

/**
 * Lấy Minigame theo ID
 */
export const fetchLoadingIdWheel = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/minigame/all/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error getting minigame:', error);
    throw error.response?.data || { message: 'Failed to get minigame' };
  }
};

/**
 * Thêm Minigame mới
 */
export const fetchAddWheel = async (data) => {
  try {
    const response = await apiClient.post('/api/minigame/create', data);
    return response.data;
  } catch (error) {
    console.error('Error adding minigame:', error);
    throw error.response?.data || { message: 'Failed to add minigame' };
  }
};

/**
 * Sửa Minigame
 */
export const fetchEditWheel = async (id, formData) => {
  try {
    const response = await apiClient.put(`/api/minigame/update/${id}`, formData);
    return response.data;
  } catch (error) {
    console.error('Error updating minigame:', error);
    throw error.response?.data || { message: 'Failed to update minigame' };
  }
};

/**
 * Xóa Minigame
 */
export const fetchDeleteWheel = async (id) => {
  try {
    const response = await apiClient.delete(`/api/minigame/delete/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting minigame:', error);
    throw error.response?.data || { message: 'Failed to delete minigame' };
  }
};

/**
 * Toggle Status Minigame
 */
export const fetchToggleStatusWheel = async (id) => {
  try {
    const response = await apiClient.put(`/api/minigame/${id}/toggle-status`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error toggling minigame status:', error);
    throw error.response?.data || { message: 'Failed to toggle status' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingWheel,
  fetchLoadingIdWheel,
  fetchAddWheel,
  fetchEditWheel,
  fetchDeleteWheel,
  fetchToggleStatusWheel,
};

